import React, { useState, useEffect, useMemo } from 'react'
import { useParams, useNavigate } from 'react-router-dom'

import TabsMui from '../../../layout/TabsMui'
import OcOrderTab from './tabs/OcOrderTab'
import OcInvoicedTab from './tabs/OcInvoicedTab'
import OcErrorTab from './tabs/OcErrorTab'
import OcRequestedTab from './tabs/OcRequestedTab'
import LoadingScreen from '../../../components/LoadingScreen'
import useFetchOcOverview from '../hooks/useFetchOcOverview'
import { STATUS_UI_MAP, OC_TABS } from '../constants/ocConstants'

import { OC_TAB_VALUES } from '../constants/ocConstants'

const DEFAULT_TAB = OC_TAB_VALUES.ORDER
const ERROR_TAB = OC_TAB_VALUES.ERROR


const ShowOcView = () => {
  const { id, mode } = useParams()
  const navigate = useNavigate()

  const isErrorRoute = mode === 'error'

  const [activeTab, setActiveTab] = useState(DEFAULT_TAB)
  const [reprocessSuccess, setReprocessSuccess] = useState(false)

  const { data, loading, error } = useFetchOcOverview(id, isErrorRoute)

  const rawStatus = data?.status?.status
  const statusUI = STATUS_UI_MAP?.[rawStatus] || null

  const hasError = isErrorRoute || rawStatus === 'error'

  const visibleTabs = useMemo(() => {
    if (hasError) {
      return OC_TABS.filter(tab => tab.value === OC_TAB_VALUES.ERROR)
    }

    return OC_TABS.filter(tab => tab.value !== OC_TAB_VALUES.ERROR)
  }, [hasError])

  useEffect(() => {
    setActiveTab(hasError ? ERROR_TAB : DEFAULT_TAB)
  }, [hasError])

  useEffect(() => {
    if (!reprocessSuccess) return
    const timer = setTimeout(() => setReprocessSuccess(false), 4000)
    return () => clearTimeout(timer)
  }, [reprocessSuccess])

  const handleReprocessSuccess = (newOrderId) => {
    if (!newOrderId) return
    setReprocessSuccess(true)
    navigate(`/ordenes_oc_details/${newOrderId}`, { replace: true })
  }

  const commonProps = hasError
    ? {
      purchaseOrder: data?.purchase_order,
      lines: data?.lines,
      downloads: data?.downloads,
      details: data?.status.details
    }
    : {
      purchaseOrder: data?.purchase_order,
      client: data?.client,
      salesman: data?.salesman,
      lines: data?.lines,
      summary: data?.summary,
      downloads: data?.downloads,
      tabsOrders: data?.tabs_orders,
      errors: data?.errors,
      last_activity_at: data?.last_activity_at,
      status: data?.status.status,
      insertionErrorDetails: data?.status?.details,
      onReprocessSuccess: handleReprocessSuccess
    }


  if (loading) {
    return <LoadingScreen text="Cargando..." />
  }

  return (
    <>
      {reprocessSuccess && (
        <div className="alert alert-success">
          Orden reprocesada correctamente
        </div>
      )}

      <div className="main-show-header">
        <h2>
          Orden de compra: #{data?.purchase_order?.db_ref || '-'}
        </h2>
      </div>

      <div className="index-table">
        <div className="show-area">
          <TabsMui
            tabs={Array.isArray(visibleTabs) ? visibleTabs : []}
            activeTab={activeTab}
            onChange={setActiveTab}
            scrollable={(Array.isArray(visibleTabs) ? visibleTabs : []).length > 1}
            appearance="modern"
            status={
              <>
                <span>Estado:</span>
                <span className={`order-status ${statusUI?.className || ''}`}>
                  {statusUI?.label || rawStatus || '-'}
                </span>
              </>
            }
          />
          <div className="tab-content-area">
            {activeTab === OC_TAB_VALUES.ERROR && <OcErrorTab {...commonProps} />}
            {!hasError && activeTab === OC_TAB_VALUES.ORDER && <OcOrderTab {...commonProps} />}
            {!hasError && activeTab === OC_TAB_VALUES.REQUESTED && <OcRequestedTab {...commonProps} />}
            {!hasError && activeTab === OC_TAB_VALUES.INVOICED && <OcInvoicedTab {...commonProps} />}
          </div>
        </div>
      </div>
    </>
  )
}

export default ShowOcView
